import { render } from "./LevelModal.vue?vue&type=template&id=ed9dfdc4"
import script from "./LevelModal.vue?vue&type=script&lang=js"
export * from "./LevelModal.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__